import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'clearUnderscore' })

export class UnderscorePipe implements PipeTransform {
  transform(value: string): string {
    return value ? value.replace(/[_]/g, ' ') : '';
  }
}
